import React,{useState,useEffect} from 'react'
import AppHeader from '../components/AppHeader'
import { useParams } from 'react-router-dom';
import portalServices from '../portalServices';
import moment from 'moment';

import useSystemMasterList from '../../../hooks/useSystemMasterList';
import ReopenComplaint from '../components/ReopenComplaint';

function ComplaintDetailsPage() {
    let { gid } = useParams();
    const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);
    const [complaint,setComplaintDetails] = useState(null);

    const getComplaintDetails = () =>{
        setComplaintDetails(null);
        portalServices.getComplaintById(gid).then(res=>{
            setComplaintDetails(res.data);
        }).catch(error=>{
            //AppAlert("Somthing went Wrong while loading complaint Try again","error")
        }).finally(()=>{  
        })  
        
    }

    useEffect(()=>{
        getComplaintDetails();
    },[gid])


    return (
        <>
            <AppHeader/>
            <div className='container'>
            {complaint &&
                <div className='col-md-4 col-sm-12' key={complaint.id}>
                    <div className='card mb-2'>
                        {complaint.photo !== null && <img src={complaint.photo} class="card-img-top" alt="complaint image" /> }
                        <div className='card-body'>
                            <div><span className='fw-bold'>Complaint ID : </span>{complaint.id}</div>
                            <div><span className="fw-bold">Complaint About : </span> {getMasterLabel("grievance-type",complaint.grievanceType)}</div>
                            <div><p>{complaint.details}</p></div>
                            
                            {complaint.audioMessage !== null && complaint.audioMessage !=="" &&
                                <audio controls>
                                    <source src={complaint.audioMessage} type="audio/ogg" />
                                </audio>
                            }
                            <div> 
                                <span className="fw-bold">Current Status</span> {getMasterLabel("grievance-status",complaint.grievanceStatus)}
                            </div>
                            <div><span className='fw-bold'>Ward No : {complaint.wardNo}</span></div>
                            <div>{complaint.address}</div>
                            <div className='border p-2 rounded my-2'><span className="fw-bold"> Date : </span>{ moment(complaint.created_at).format("lll")} </div>
                            <a target='_blank' href={"https://www.google.com/maps/dir//"+complaint.latitude+", "+complaint.longitude} >Show Direction on Map</a>

                            <ReopenComplaint complaint={complaint} calback={getComplaintDetails} />
                            
                        </div>
                        
                        { complaint.grievanceStatus === 1 &&
                            <div className={ 'border border-danger border-2 mb-0'}>
                            </div>
                        }
                        
                        { complaint.grievanceStatus === 2 &&
                            <div className={ 'border border-warning border-2 mb-0'}>
                            </div>
                        }
                        { complaint.grievanceStatus === 3 &&
                            <div className={ 'border border-success border-2 mb-0'}>
                            </div>
                        }

                        { complaint.grievanceStatus === 4 &&
                            <div className={ 'border border-danger border-2 mb-0'}>
                            </div>
                        }



                    </div>
                </div>
            }
            </div>
        </>
    )
}

export default ComplaintDetailsPage